import { Box, CircularProgress, Tooltip, Typography } from '@mui/material'

/**
 * ConfidenceBadge — small circular indicator showing AI match confidence.
 * - Green ring (>= 0.80): high confidence, auto-action safe
 * - Yellow ring (0.60 - 0.79): medium, review recommended
 * - Red ring (< 0.60): low, manual review needed
 *
 * 🔴 `intent` traegt seit N2b (2026-09-07) ZWEI Bedeutungen, je nach Aufrufer —
 * und deshalb steht hier ein Satz dazu statt nur ein Typ:
 *   - ROHE Modellkennung (`llm_intent` / `llm_verdict`) aus `RMAInbox`,
 *     `POInbox`, `pages/RedirectReviewInbox`. Fuer die ist das
 *     `replace(/_/g, ' ')` unten der einzige Aufbereitungsschritt.
 *   - ein FERTIGES Etikett aus `AdditionalTopicsBlock`, das dort schon durch
 *     `issueTypeAnzeige` gelaufen ist. Auf einem fertigen Etikett ist das
 *     `replace` ein Nulldurchgang (es traegt keinen Unterstrich).
 * Die Komponente bleibt damit absichtlich unveraendert: die Umstellung gehoert
 * an die Aufrufstelle, die einen `issue_type` hat, nicht in die geteilte
 * Komponente, die vier Aufrufer bedient. (Regel-16-Gate, W-1.)
 *
 * ⚠️ Der eine Fall, in dem die zwei Bedeutungen auseinanderlaufen: ein
 * UNBEKANNTER `issue_type` MIT Unterstrich. Der Chip daneben zeigte ihn roh,
 * dieser Tooltip humanisiert ihn. Gemessen 2026-09-07 an prod: **null** solche
 * Werte, ueber Faelle, Posteingang und Ereignisse zusammen. Empirisch
 * begrenzt, nicht konstruktiv ausgeschlossen.
 */
export default function ConfidenceBadge({ confidence, intent, size = 24 }) {
  if (confidence == null || confidence === 0) return null

  const pct = Math.round(confidence * 100)
  const color =
    confidence >= 0.80 ? 'success' :
    confidence >= 0.60 ? 'warning' : 'error'

  const colorValue =
    color === 'success' ? 'success.main' :
    color === 'warning' ? 'warning.main' : 'error.main'

  return (
    <Tooltip title={`AI Confidence: ${pct}%${intent ? ` — ${intent.replace(/_/g, ' ')}` : ''}`} arrow>
      <Box sx={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
        <CircularProgress
          variant="determinate"
          value={pct}
          size={size}
          thickness={5}
          sx={{ color: colorValue }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" sx={{ fontSize: 8, fontWeight: 700, color: colorValue, lineHeight: 1 }}>
            {pct}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  )
}
